import _ from 'underscore';
import { BaseSchemaProcessor } from './base-schema-processor';

export class LinkedStoreSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const updatedSchema = super.updateEntitySchemaForFeatures(entitySchema);

    updatedSchema.properties = {
      Status: {
        filterable: true,
        title: 'Status',
        type: 'string',
        property: 'Status',
        originalProperty: 'Status',
        required: true,
        maximum: 1,
        enumValueMap: {
          0: 'Pending',
          1: 'Approved',
          2: 'Rejected',
          3: 'Expired',
          4: 'Cancelled',
        },
        enum: [
          0,
          1,
          2,
          3,
          4,
        ],
        operators: [
          'eq',
        ],
        chooseType: 'radio',
      },
    };

    return updatedSchema;
  }

  updateOdataOptions(odataOptions) {
    super.updateOdataOptions(odataOptions);

    _.extendOwn(odataOptions.custom, {
      Status: {
        eq: (value) => {
          const status = value.split('\'')[1];
          const url = `Status eq '${status}'`;

          return url;
        },
      },
    });

    return odataOptions;
  }
}
